
import { Component, Vue, Watch } from "vue-property-decorator";
import { LogHelper } from "@/common/LogHelper";
// import WarningPage from "@/views/components/WarningPage/WarningPage.vue";
@Component({
  name: "about",
  components: {
    // WarningPage
  },
})
export default class extends Vue {
  mounted() {
    this.ShowUpdateRecord();
    // 获取当前日期时间
    var myDate = new Date();
    myDate.toLocaleDateString(); //获取当前日期
    this.nowTime = myDate.toLocaleString();
  }
  private nowTime;
  public BackToFirstView() {
    this.$router.push(`/dashboard`);
  }
  public about = {
    currentVersion: "1.4.6.0",
    updateHistory: [],
  };
  public latestVersion = "";

  public ShowUpdateRecord() {
    const _data = require("./updaterecord.json");
    this.about = _data;
    this.about.updateHistory.forEach((element, index) => {
      if (index == 0) {
        this.$set(element, "color", "#0bbd87");
        this.latestVersion = element.version;
      }
    });
    // LogHelper.WriteLog(JSON.stringify( this.about.updateHistory));
  }
  // 获取当前日期时间
  public timestampToTime(timestamp) {
    var date = new Date(timestamp);
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + " ";
    var hh =
      date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ":";
    var mm =
      date.getMinutes() < 10
        ? "0" + date.getMinutes()
        : date.getMinutes() + ":";
    var ss = date.getSeconds() < 10 ? "0" + date.getDate() : date.getSeconds();
    return Y + M + D + hh + mm + ss;
  }
}
